import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class AdminOverviewMooringAdministrator {

  @bindable
  private isPlm: boolean;
}
